import "./Gradient.scss";

export default function Gradient({ height }) {
    return <div className="gradient" style={{ height: height }} />;
}
